'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.optional = exports.combine = exports.validatorFromFunction = exports.array = exports.validators = undefined;

var _validators = require('./validators');

Object.defineProperty(exports, 'validators', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_validators).default;
  }
});

var _utils = require('./utils');

Object.defineProperty(exports, 'array', {
  enumerable: true,
  get: function get() {
    return _utils.array;
  }
});
Object.defineProperty(exports, 'validatorFromFunction', {
  enumerable: true,
  get: function get() {
    return _utils.validatorFromFunction;
  }
});
Object.defineProperty(exports, 'combine', {
  enumerable: true,
  get: function get() {
    return _utils.combine;
  }
});
Object.defineProperty(exports, 'optional', {
  enumerable: true,
  get: function get() {
    return _utils.optional;
  }
});
exports.validate = validate;

var _lodash = require('lodash.pairs');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.frompairs');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.isfunction');

var _lodash6 = _interopRequireDefault(_lodash5);

var _lodash7 = require('lodash.isobject');

var _lodash8 = _interopRequireDefault(_lodash7);

var _lodash9 = require('lodash.isempty');

var _lodash10 = _interopRequireDefault(_lodash9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function validate(data, validationSpec) {
  var pairs = (0, _lodash2.default)(validationSpec);

  var errorPairs = pairs.reduce(function (acc, pair) {
    var key = pair[0];
    var value = pair[1];

    if (Array.isArray(value)) {
      value = (0, _utils.array)(value[0]);
    }

    if ((0, _lodash6.default)(value)) {
      var validationResult = value(data[key]);
      if (!validationResult) {
        return acc;
      } else {
        return [].concat(_toConsumableArray(acc), [[key, validationResult]]);
      }
    }

    if ((0, _lodash8.default)(value)) {
      var _validationResult = validate(data[key] || {}, value);

      if ((0, _lodash10.default)(_validationResult)) {
        return acc;
      } else {
        return [].concat(_toConsumableArray(acc), [[key, _validationResult]]);
      }
    }

    return acc;
  }, []);

  return (0, _lodash4.default)(errorPairs);
}